import posthog from 'posthog-js';

// Events always fire. Which PostHog project they land in is decided
// automatically by hostname in utils/posthog-provider.js — localhost and
// staging go to the testing project, so local events never touch production
// data and there is nothing to switch on or off here.
export function track(name, props = {}) {
	try {
		if (posthog) {
			posthog.capture(name, props);
		}
	} catch (e) {
		/* tracking must never break the app */
	}
}
